import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import Modal from 'antd/lib/modal';

export const StyledSettingsPage = styled('div')``;
export const QuillGlobal = createGlobalStyle`
  .ql-editor {
    min-height: 150px;
  }`;

export const InputNumberGlobal = createGlobalStyle`
  .custom-input-number{
    width: 100%
  }`;

export const StyledCustomSuffix = styled('div')`
  height: 100%;
  background-color: ${(props) => props.theme.suffixBackground};
  border-left: 1px solid ${(props) => props.theme.colorBorder};

  .ant-form-item-control-input-content {
    height: 100%;
  }

  .ant-form-item {
    height: 100%;
    margin: 0;

    .ant-row {
      height: 100%;
    }
  }

  .ant-upload-wrapper {
    height: 100%;

    .ant-upload {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      padding: 0 8px;
      cursor: pointer;
    }
  }
`;

export const StyledUploadLogoModal = styled(Modal)`
  .ant-input-affix-wrapper {
    padding: 0;
    height: calc(1.5em + 1.3rem + 2px); //Paņemts no vecā
  }
`;
